import { Issue } from "@/_models/issue.interface";
import { CombinedTaskCardMobileComponent } from "@/components/shared/flight-list/combined-task-card-mobile/combined-task-card-mobile.component";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import {
    AssignedItemMeta,
    AssignedItemMetaService,
    EMPTY_ASSIGNED_ITEM_META,
} from "@/_services/assigned-item-meta.service";
import { listItemTitle } from "@/_utility/list-item-title.util";
import { RECORD_TYPE_BADGES } from "@/_utility/record-type-badge.util";
import { AssignedItemMetaComponent } from "../assigned-item-meta/assigned-item-meta.component";
import { Component, Input, OnChanges } from "@angular/core";
import { TagModule } from "primeng/tag";

@Component({
    selector: "app-issue-task-card",
    standalone: true,
    imports: [
        SharedComponentsModule,
        AssignedItemMetaComponent,
        CombinedTaskCardMobileComponent,
        TagModule,
    ],
    templateUrl: "./issue-task-card.component.html",
    styleUrls: [
        "./issue-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class IssueTaskCardComponent implements OnChanges {
    @Input() issue: Issue;
    @Input() showEdit: boolean = false;

    badge = RECORD_TYPE_BADGES.issue;
    title: string = this.badge.untitledTitle;
    meta: AssignedItemMeta = EMPTY_ASSIGNED_ITEM_META;

    constructor(private metaService: AssignedItemMetaService) {}

    ngOnChanges(): void {
        this.title = listItemTitle(this.issue, this.badge.untitledTitle);
        this.meta = this.metaService.forCase(this.issue);
    }
}
